import '../styles/LandingStatement.css';
import React from 'react';
import { motion } from 'motion/react';

const STEPS = [
  {
    title: 'Name your starting points.',
    body: 'Supply one or more web pages or web directory locations on New Crawl.'
  },
  {
    title: 'The crawl runs in the background.',
    body: 'dbaseextractor fetches and traverses the pages you gave it, and records each crawl with its status and progress.'
  },
  {
    title: 'Emails become lead records.',
    body: 'Every email address found is stored with the page it came from and the crawl it belongs to — durable, reviewable records kept in your account.'
  }
];

function LandingStatement() {
  return (
    <section className="ls-root" aria-labelledby="ls-heading">
      <div data-content-rail="primary">
        <div className="ls-col">
          <div className="ls-mark" aria-hidden="true">
            <svg className="ls-mark-svg" viewBox="0 0 64 14" fill="none">
              <path
                className="ls-mark-path"
                d="M1 9C7 8 10 3 16 4.5S24 12 31 10.5 41 2.5 47 4.5s9 6 16 3.5"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
              />
            </svg>
            <p className="ls-label">How it works</p>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 8 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
          >
            <h2 className="ls-heading" id="ls-heading">
              Crawl the web. Keep the emails.
            </h2>
            <p className="ls-lede">
              dbaseextractor crawls web pages and web directories to find and extract email leads
              on the internet, and stores what it finds as a persistent lead list you can return
              to.
            </p>
            <ol className="ls-steps">
              {STEPS.map((step, i) => (
                <li className="ls-step" key={step.title}>
                  <span className="ls-step-num" aria-hidden="true">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span>
                    <strong>{step.title}</strong> {step.body}
                  </span>
                </li>
              ))}
            </ol>
            <p className="ls-aside">
              Crawls and leads are private to the researcher who started them, and remain
              available across sessions — <em>long, careful work, kept in order.</em>
            </p>
          </motion.div>

          <div className="ls-actions">
            <a className="ls-cta" href="/sign-up">
              Sign Up
              <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
                <path
                  d="M3 10h13M11 4.5 16.5 10 11 15.5"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
            <a className="ls-login" href="/login">
              Already have an account? Login
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LandingStatement;